import {NgModule} from '@angular/core';
import {FilterComponent} from './filter.component';
import {CommonModule} from '@angular/common';
import {MaterialModule} from '../../app.material.module';
import {FilterModalComponent} from './modal/filter-modal.component';
import {ContentModule} from '../../services/content/content.module';
import {AccordionModule} from '../accordion/accordion.module';
import {FormsModule} from '@angular/forms';
import {ButtonModule} from '../button/button.module';
import {InterestSelectorModule} from '../interest/interest-selector/interest-selector.module';
import {FilterChipsComponent} from './chips/filter-chips.component';

@NgModule({
    declarations: [FilterComponent, FilterModalComponent, FilterChipsComponent],
    imports: [
        CommonModule,
        ContentModule,
        MaterialModule,
        AccordionModule,
        FormsModule,
        ButtonModule,
        InterestSelectorModule
    ],
    exports: [FilterComponent, FilterModalComponent, FilterChipsComponent]
})
export class FilterModule {}
